 import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
 import { useLocation } from "react-router-dom";
import Contex from "../Context/CreateContext.js";
	import { useParams} from "react-router-dom";
const Researcher2 = () => {

  const {gatecat} = useParams()
  const contex = useContext(Contex);
  const { handleNoteEdit, deleteScholar,  fetchResearchItemData ,  ResearchItemData, handleEditResearchItem, handleDeleteResearchItem} = contex;
    const location = useLocation();
    useEffect(() => {
    (async () => {
     await  fetchResearchItemData();
      
})();
 
}, [ ])
  const path = location.pathname;
 
  const category =  path.split('/')
  // const cat = category[1]
 

	var catItem = []
ResearchItemData.data && ResearchItemData.data.map((item)=>{
  if(item.category === gatecat){
    // return item
    catItem.push(item)

  }
})





  const token = localStorage.getItem("at");

  return (
    <div className="mt-0">

    
   <section className="text-gray-600 body-font">
        <div className="container md:px-5  mt-0 md:pb-24 mx-auto">
          <div class=" text-2xl md:text-5xl  mb-2 md:mb-8 text-center font-extrabold ...">
            <span class="bg-clip-text text-transparent bg-gradient-to-r from-yellow-500 to-violet-500 mt-1   ">
              Research Gate Published Paper
            </span>
          </div>
          {token && <>  <div className=" flex justify-center items-center  mx-auto">
            <button className="  bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-black py-2 px-4  border border-blue-500 hover:border-transparent rounded">
              <Link to="/addResearchItem" className="no-underline "> add new one</Link>

            </button>
          </div></>}
          <section
            className="text-gray-600 body-font overflow-hidden"
            style={{ userSelect: "auto" }}
          >
            <div
              className="container px-5 py-24 mx-auto"
              style={{ userSelect: "auto" }}
            >
              <div
                className="flex flex-wrap -m-12"
                style={{ userSelect: "auto" }}
              >
                {catItem &&
                  catItem.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className=" p-5 lg:p-12 md:w-1/2 lg:w-1/3  2xl:w-1/4  flex flex-col shadow"
                        style={{ userSelect: "auto" }}
                      >
                        {token && (
                          <>
                            {" "}
                            <span
                              className="flex  py-1 px-2 rounded    text-xs font-medium tracking-widest"
                              style={{ userSelect: "auto" }}
                            >
                              {/* ❤😊   */}
                              <FaRegEdit

                                className="mx-2 cursor-pointer"
                                size={20}
                                onClick={async() =>  await handleEditResearchItem({ id: item._id, title: item.title, description: item.desc, authors: item.authors, pub_date: item.pub_date, url: item.url, category: item.category})}
                              />

                              <RiDeleteBin5Line
                                onClick={async() => await handleDeleteResearchItem({ id: item._id })}
                                className="cursor-pointer"
                                size={20}
                              />
                            </span>
                          </>
                        )}

                        <span
                          className="inline-block py-1 px-2 rounded bg-yellow-50 text-yellow-500 text-xs font-medium tracking-widest"
                          style={{ userSelect: "auto" }}
                        >
                          Published at :{item.pub_date}{" "}
                        </span>
                        <h2
                          className={`${item.title.length > 100
                            ? "mb-1"
                            : "pb-2 md:mb-20 lg:pb-5"
                            }  font-serif lg:text-2xl text-xl title-font font-medium text-gray-900 mt-4`}
                          style={{ userSelect: "auto" }}
                        >
                          {item.title.length > 169
                            ? `${item.title.charAt(0).toUpperCase() +
                            item.title
                              .slice(1)
                              .toLowerCase()
                              .substring(0, 169)
                            }...`
                            : item.title.charAt(0).toUpperCase() +
                            item.title.slice(1).toLowerCase()}{" "}
                        </h2>
                        <p
                          className="leading-relaxed mb-8  text-justify"
                          style={{ userSelect: "auto" }}
                        >
                          {item.desc && item.desc.length > 100 ? item.desc.substring(0, 323) : item.desc}...
                          {/* {item.desc.length ===0 ?item.desc : item.desc.length> 100 ? item.desc.substring(0, 323):item.desc}... */}
                        </p>
                        <div
                          className="flex items-center flex-wrap pb-4 mb-4 border-b-2 border-gray-100 mt-2 w-full"
                          style={{ userSelect: "auto" }}
                        >
                          <a
                            className="text-yellow-500 inline-flex items-center cursor-pointer"
                            style={{ userSelect: "auto" }}
                            target="blank"
                            href={item.url}
                          >
                            Learn More
                            <svg
                              className="w-4 h-4 ml-2"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={2}
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              style={{ userSelect: "auto" }}
                            >
                              <path
                                d="M5 12h14"
                                style={{ userSelect: "auto" }}
                              />
                              <path
                                d="M12 5l7 7-7 7"
                                style={{ userSelect: "auto" }}
                              />
                            </svg>
                          </a>
                          <span
                            className="text-black font-bold mr-3 inline-flex items-center ml-auto leading-none text-sm   py-1 border-r-2 border-gray-200"
                            style={{ userSelect: "auto" }}
                          >
                            <svg
                              className="w-4 h-4 mr-1"
                              stroke="currentColor"
                              strokeWidth={2}
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              viewBox="0 0 24 24"
                              style={{ userSelect: "auto" }}
                            >
                              <path
                                d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                style={{ userSelect: "auto" }}
                              />
                              <circle
                                cx={12}
                                cy={12}
                                r={3}
                                style={{ userSelect: "auto" }}
                              />
                            </svg>
                            Authors:
                          </span>
                          <span
                            className="inline-flex items-center leading-none text-sm"
                            style={{ userSelect: "auto" }}
                          >
                            <svg
                              className="w-4 h-4 mr-1"
                              stroke="currentColor"
                              strokeWidth={2}
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              viewBox="0 0 24 24"
                              style={{ userSelect: "auto" }}
                            >
                              <path
                                d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"
                                style={{ userSelect: "auto" }}
                              />
                            </svg>
                            {item.authors.length > 30
                              ? `${item.authors.substring(0, 27)}...`
                              : item.authors}{" "}
                          </span>
                        </div>
                      </div>
                    );
                  })}{" "}
              </div>
            </div>
          </section>
        </div>
      </section>
      <button
        type="button"
        data-mdb-ripple="true"
        data-mdb-ripple-color="light"
        className="inline-block p-3 bg-red-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out hidden bottom-5 right-5 fixed"
        id="btn-back-to-top"
      >
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          className="w-4 h-4"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
          />
        </svg>
      </button>


    </div>
  );
};

export default  Researcher2;
